import C from './consumer';

export default C;
